import $ from '@ali/tarzan-zepto';
import events from 'events';
import './index.scss';

class UnRead extends events {
  constructor(config) {
    super();

    this.nodes = [];

    this.$container = config.container;
    this.__init();
    this.__bindEvent();
  }

  __init() {
    this.$el = $(`<button class="m-alicare-unread">
      <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-forward"></use>
        </svg>
      <span><span class="m-alicare-unread-count">0</span>条新消息</span>
    </button>`);
    this.$count = this.$el.find('.m-alicare-unread-count');
    this.$container.append(this.$el);
  }

  show() {
    this.$el.show();
  }

  hide() {
    this.nodes = [];
    this.$el.hide();
  }

  add(node) {
    this.nodes.push(node);
    this.$count.text(`${this.nodes.length}`);
    this.show();
  }

  __bindEvent() {
    this.$el.on('tap', () => {
      this.emit('trigger', this.nodes[0]);
      this.hide();
    });
  }
}

export default UnRead;



// WEBPACK FOOTER //
// ./src/component/view/body/unread/index.js